import { render, staticRenderFns } from "./CornerRibbon.vue?vue&type=template&id=c1f97dc4&scoped=true&"
import script from "./CornerRibbon.vue?vue&type=script&lang=js&"
export * from "./CornerRibbon.vue?vue&type=script&lang=js&"
import style0 from "./CornerRibbon.vue?vue&type=style&index=0&id=c1f97dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-internal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f97dc4",
  null
  
)

export default component.exports